import { render, staticRenderFns } from "./recommended.vue?vue&type=template&id=45c7ddb4&scoped=true"
import script from "./recommended.vue?vue&type=script&lang=js"
export * from "./recommended.vue?vue&type=script&lang=js"
import style0 from "./recommended.vue?vue&type=style&index=0&id=45c7ddb4&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "45c7ddb4",
  null
  
)

export default component.exports